import { render, staticRenderFns } from "./TotalTargetOngoing.vue?vue&type=template&id=b531e308"
import script from "./TotalTargetOngoing.vue?vue&type=script&lang=js"
export * from "./TotalTargetOngoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports